import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import { userService } from '../../_services';
import { useMultiplePopups } from '../../hooks/usePopup';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { BetaBadge } from '@/components/ui/BetaBadge';
import { FileText, FileSpreadsheet, Download, DollarSign, Calendar, ClipboardList } from 'lucide-react';

import ReportPopup from './ReportPopup';
import MinimumPayoutReportPopup from './MinimumPayoutReport';
import CommissionPayoutAllBinJDPopup from './CommissionPayoutAllBinJD';
import TransitionReportPopup from './TransitionReportPopup';
import WholesalerCommissionReportPopup from './WhCommissionReport';
import MonthlyClaimsReport from './MonthlyClaimsReport';

function Reports({ AnalyticData }) {
    const [userdata] = useState(() => {
        try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
    });

    const { popups, togglePopup, closePopup } = useMultiplePopups([
        'commissionPayout', 'minimumPayout', 'commissionPayoutAllBin', 'rawTransaction', 'wholesalerCommission', 'monthlyClaims'
    ]);

    const [transitionReportData, setTransitionReportData] = useState({ dashboardName: '', wholesaler_Id: '', unique_ObjectId: '' });

    const userType = userService.Get_User_Type();
    if (userService.Check_LoggedIn_Status() === 'Login') return <Redirect to="/login" />;
    if (['admin', 'distributor', 'subadmin'].includes(userType?.toLowerCase())) return <Redirect to='/pageNotFound' />;

    const handleTransitionPopup = () => {
        setTransitionReportData({ dashboardName: userdata?.wholesaler, wholesaler_Id: userdata?.wholesaler_Id, unique_ObjectId: userdata?.unique_ObjectId });
        togglePopup('rawTransaction');
    };

    const reportItems = [
        { id: 'commissionPayout', title: 'Commission Payout Report', description: 'View commission payout details', icon: DollarSign, onClick: () => togglePopup('commissionPayout'), show: userdata?.wholesaler !== "Avenel_llll" },
        { id: 'minimumPayout', title: 'Minimum Payout Report', description: 'View minimum payout thresholds', icon: FileText, onClick: () => togglePopup('minimumPayout'), show: userdata?.username === "JD Gibson" || userdata?.wholesaler_Id === 61 },
        { id: 'commissionPayoutAllBin', title: 'Commission Payout Report (All Bins)', description: 'Commission payouts across all BINs', icon: FileSpreadsheet, onClick: () => togglePopup('commissionPayoutAllBin'), show: userdata?.username === "JD Gibson" || userdata?.wholesaler_Id === 61 },
        { id: 'rawTransaction', title: 'Generate Raw Transaction Report', description: 'Export raw transaction data', icon: Download, onClick: handleTransitionPopup, show: userdata?.wholesaler !== "Avenel_llll" },
        { id: 'wholesalerCommission', title: 'Wholesaler Commission Report', description: 'View wholesaler commission summary', icon: ClipboardList, onClick: () => togglePopup('wholesalerCommission'), show: userdata?.wholesaler !== "Avenel_llll" },
        { id: 'monthlyClaims', title: 'Monthly Claims Report', description: 'Monthly claims breakdown', icon: Calendar, onClick: () => togglePopup('monthlyClaims'), show: true }
    ];

    return (
        <PagesWrapper>
            <div className="space-y-6">
                <div className="flex items-center">
                    <h1 className="text-2xl font-semibold text-foreground">
                        Reports
                        <BetaBadge />
                    </h1>
                </div>

                {userdata?.wholesaler === "Avenel_llll" ? (
                    <Card><CardContent className="p-8 text-center"><FileText className="h-12 w-12 mx-auto mb-4 text-muted-foreground opacity-50" /><p className="text-lg font-medium text-muted-foreground">Coming Soon</p></CardContent></Card>
                ) : (
                    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {reportItems.filter(item => item.show).map((item) => {
                            const Icon = item.icon;
                            return (
                                <Card key={item.id} className="cursor-pointer hover:shadow-md transition-all hover:border-primary/50 group" onClick={item.onClick}>
                                    <CardContent className="p-3 sm:p-4">
                                        <div className="flex items-start gap-4">
                                            <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 group-hover:bg-primary/20 transition-colors">
                                                <Icon className="h-6 w-6 text-primary" />
                                            </div>
                                            <div className="min-w-0 flex-1">
                                                <p className="font-medium text-foreground">{item.title}</p>
                                                <p className="text-sm text-muted-foreground mt-1">{item.description}</p>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>
                            );
                        })}
                    </div>
                )}
            </div>

            {popups.commissionPayout && <ReportPopup text='Commission Payout Report' closePopup={() => closePopup('commissionPayout')} />}
            {popups.wholesalerCommission && <WholesalerCommissionReportPopup text='Wholesaler Commission Report' closeCommissionPopup={() => closePopup('wholesalerCommission')} />}
            {popups.minimumPayout && <MinimumPayoutReportPopup text='Minimum Payout Report' closePopup={() => closePopup('minimumPayout')} />}
            {popups.commissionPayoutAllBin && <CommissionPayoutAllBinJDPopup text='Commission Payout Report(All Bins)' closePopup={() => closePopup('commissionPayoutAllBin')} />}
            {popups.rawTransaction && <TransitionReportPopup text='Generate Raw Transaction Report' calldata="callonce" closeRawTransactionPopup={() => closePopup('rawTransaction')} wholesaler_name={transitionReportData.dashboardName} wholeSaler_id={transitionReportData.wholesaler_Id} unique_ObjectId={transitionReportData.unique_ObjectId} />}
            {popups.monthlyClaims && <MonthlyClaimsReport text='Monthly Claims Report' calldata="callonce" closeMonthlyClaimsPopup={() => closePopup('monthlyClaims')} wholesaler_name={userdata?.wholesaler} wholeSaler_id={userdata?.wholesaler_Id} unique_ObjectId={userdata?.unique_ObjectId} />}
        </PagesWrapper>
    );
}

export default Reports;
